<template lang="pug">
v-card(flat)
  v-toolbar(flat, dense)
    .subtitle-2 Payment Method
    v-spacer
    Edit(@done="load")
  StripeSources(:id="id", v-if="id", ref="sources")
</template>

<script>
import { EventBus } from "@/event-bus.js";
import { mapGetters } from "vuex";
import Edit from "./Edit";
import StripeSources from "/libs/components/Stripe/Sources";

export default {
  components: { Edit, StripeSources },
  computed: {
    ...mapGetters(["biz"]),
    id() {
      return this.biz?.payments?.customer;
    },
  },
  mounted() {
    EventBus.$on("switch-biz", this.load);
  },
  destroyed() {
    EventBus.$off("switch-biz", this.load);
  },
  methods: {
    async load() {
      this.$refs.sources.load();
    },
  },
};
</script>
